export const GUESTPASS_PROMO_CODE = 'guestpass7dtri'

export const DEFAULT_PROMO_CODE = 'wmq30intro'
export const DOWNSELL_PROMO_CODE = 'wmq71intro'

export const HSA_FSA_PROMO_CODE = 'hsafsa'
